import _regeneratorRuntime from 'babel-runtime/regenerator';

var _marked =
/*#__PURE__*/
_regeneratorRuntime.mark(guardarTextos),
    _marked2 =
/*#__PURE__*/
_regeneratorRuntime.mark(handleTextoCrear),
    _marked3 =
/*#__PURE__*/
_regeneratorRuntime.mark(handleTextoActualizar),
    _marked4 =
/*#__PURE__*/
_regeneratorRuntime.mark(handleTextosEliminar),
    _marked5 =
/*#__PURE__*/
_regeneratorRuntime.mark(cargarTextosZona),
    _marked6 =
/*#__PURE__*/
_regeneratorRuntime.mark(cargarTextosDoblePagina),
    _marked7 =
/*#__PURE__*/
_regeneratorRuntime.mark(watchTextosUsuario);

import { all, put, takeEvery, select, call } from 'redux-saga/effects';
import { seleccionarHerramienta } from '../../actions';
import { TEXTO_CREAR, TEXTO_ACTUALIZAR, TEXTOS_ELIMINAR, cargarTextos as cargarTextosAction } from '../../texto-usuario/actions';
import * as textosUsuarioSelectors from '../../texto-usuario/selectors';
import { getNumPaginaIzquierda, getPaginasPorPantalla } from '../../selectors/config-libro';
import { getPantallaProps } from '../../selectors';
import { PANTALLA_LIBRO_ID } from '../../constantes';
import { PUNTERO_ID, GRUPO_PIZARRA } from '../../herramientas/constantes';
import * as Util from '../../util';
import Texto from '../../texto-usuario/texto';

var getTextosZona = function getTextosZona(libroId, numPagina, numZona) {
  var key = Util.getKeyTextosZona(libroId, numPagina, numZona);
  var textos = Util.getStorageData(key);

  if (!Array.isArray(textos)) {
    return [];
  }

  return textos;
};

var getTextosPagina = function getTextosPagina(libroId, numPagina) {
  var key = Util.getKeyTextosPagina(libroId, numPagina);
  var textos = Util.getStorageData(key);

  if (!Array.isArray(textos)) {
    return [];
  }

  return textos;
}; // const esTextoVacio  = (textoHtml) => {
//     return textoHtml === '<p><br></p>'
// }


var setTextosZona = function setTextosZona(libroId, numPagina, numZona, textos) {
  var key = Util.getKeyTextosZona(libroId, numPagina, numZona);

  if (Array.isArray(textos)) {
    Util.setStorageData(key, textos.filter(function (texto) {
      return !Texto.esVacio(texto);
    }));
  }
};

var setTextosPagina = function setTextosPagina(libroId, numPagina, textos) {
  var key = Util.getKeyTextosPagina(libroId, numPagina);

  if (Array.isArray(textos)) {
    Util.setStorageData(key, textos.filter(function (texto) {
      return !Texto.esVacio(texto);
    }));
  }
};

function guardarTextos(libroId, numPagina, numZona) {
  var _textos, textos;

  return _regeneratorRuntime.wrap(function guardarTextos$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          if (!numZona) {
            _context.next = 7;
            break;
          }

          _context.next = 3;
          return select(textosUsuarioSelectors.getTextosZona, libroId, numPagina, numZona);

        case 3:
          _textos = _context.sent;
          _context.next = 6;
          return call(setTextosZona, libroId, numPagina, numZona, _textos);

        case 6:
          return _context.abrupt('return');

        case 7:
          _context.next = 9;
          return select(textosUsuarioSelectors.getTextosPagina, libroId, numPagina);

        case 9:
          textos = _context.sent;
          _context.next = 12;
          return call(setTextosPagina, libroId, numPagina, textos);

        case 12:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

function handleTextoCrear(action) {
  var _action$texto, libroId, numPagina, numZona, paginasPorPantalla, pantallaProps, numPaginaSimple;

  return _regeneratorRuntime.wrap(function handleTextoCrear$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _action$texto = action.texto, libroId = _action$texto.libroId, numPagina = _action$texto.numPagina, numZona = _action$texto.numZona;
          _context2.next = 3;
          return select(getPaginasPorPantalla, libroId);

        case 3:
          paginasPorPantalla = _context2.sent;

          if (!(paginasPorPantalla === 1)) {
            _context2.next = 13;
            break;
          }

          _context2.next = 7;
          return select(getPantallaProps, PANTALLA_LIBRO_ID);

        case 7:
          pantallaProps = _context2.sent;
          numPaginaSimple = pantallaProps.numPagina;
          _context2.next = 11;
          return call(guardarTextos, libroId, numPaginaSimple, numZona);

        case 11:
          _context2.next = 15;
          break;

        case 13:
          _context2.next = 15;
          return call(guardarTextos, libroId, numPagina, numZona);

        case 15:
          _context2.next = 17;
          return put(seleccionarHerramienta(PUNTERO_ID, GRUPO_PIZARRA));

        case 17:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

function handleTextoActualizar(action) {
  var texto, libroId, numPagina, numZona, numPaginaIzquierda, numPaginaDerecha, paginasPorPantalla, pantallaProps, numPaginaSimple;
  return _regeneratorRuntime.wrap(function handleTextoActualizar$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return select(textosUsuarioSelectors.getTextoById, action.textoId);

        case 2:
          texto = _context3.sent;
          libroId = texto.libroId, numPagina = texto.numPagina, numZona = texto.numZona;

          if (!numZona) {
            _context3.next = 8;
            break;
          }

          _context3.next = 7;
          return call(guardarTextos, libroId, numPagina, numZona);

        case 7:
          return _context3.abrupt('return');

        case 8:
          _context3.next = 10;
          return select(getNumPaginaIzquierda, libroId, numPagina);

        case 10:
          numPaginaIzquierda = _context3.sent;
          numPaginaDerecha = numPaginaIzquierda + 1;
          _context3.next = 14;
          return select(getPaginasPorPantalla, libroId);

        case 14:
          paginasPorPantalla = _context3.sent;

          if (!(paginasPorPantalla === 1)) {
            _context3.next = 24;
            break;
          }

          _context3.next = 18;
          return select(getPantallaProps, PANTALLA_LIBRO_ID);

        case 18:
          pantallaProps = _context3.sent;
          numPaginaSimple = pantallaProps.numPagina;
          _context3.next = 22;
          return call(guardarTextos, libroId, numPaginaSimple);

        case 22:
          _context3.next = 28;
          break;

        case 24:
          _context3.next = 26;
          return call(guardarTextos, libroId, numPaginaIzquierda);

        case 26:
          _context3.next = 28;
          return call(guardarTextos, libroId, numPaginaDerecha);

        case 28:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this);
}

function handleTextosEliminar(action) {
  var libroId, numPagina, numZona, paginasPorPantalla, pantallaProps, numPaginaSimple;
  return _regeneratorRuntime.wrap(function handleTextosEliminar$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          libroId = action.libroId, numPagina = action.numPagina, numZona = action.numZona;
          _context4.next = 3;
          return select(getPaginasPorPantalla, libroId);

        case 3:
          paginasPorPantalla = _context4.sent;

          if (!(paginasPorPantalla === 1)) {
            _context4.next = 13;
            break;
          }

          _context4.next = 7;
          return select(getPantallaProps, PANTALLA_LIBRO_ID);

        case 7:
          pantallaProps = _context4.sent;
          numPaginaSimple = pantallaProps.numPagina;
          _context4.next = 11;
          return call(guardarTextos, libroId, numPaginaSimple, numZona);

        case 11:
          _context4.next = 15;
          break;

        case 13:
          _context4.next = 15;
          return call(guardarTextos, libroId, numPagina, numZona);

        case 15:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked4, this);
}
/**
 * Carga los textos de usuario de la zona indicada
 * 
 * @param {libroId, numPagina, numZona} 
 */


export function cargarTextosZona(_ref) {
  var libroIdGuardado = _ref.libroIdGuardado,
      numPaginaGuardado = _ref.numPaginaGuardado,
      numZonaGuardado = _ref.numZonaGuardado;
  var textos;
  return _regeneratorRuntime.wrap(function cargarTextosZona$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return call(getTextosZona, libroIdGuardado, numPaginaGuardado, numZonaGuardado);

        case 2:
          textos = _context5.sent;
          _context5.next = 5;
          return put(cargarTextosAction(textos));

        case 5:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked5, this);
}
export function cargarTextosDoblePagina(_ref2) {
  var libroId = _ref2.libroId,
      numPagina = _ref2.numPagina;

  var numPaginaIzquierda, paginasPorPantalla, textosPagina, textos, textosPaginaIzquierda, textosPaginaDerecha, _textos2;

  return _regeneratorRuntime.wrap(function cargarTextosDoblePagina$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return select(getNumPaginaIzquierda, libroId, numPagina);

        case 2:
          numPaginaIzquierda = _context6.sent;
          _context6.next = 5;
          return select(getPaginasPorPantalla, libroId);

        case 5:
          paginasPorPantalla = _context6.sent;

          if (!(paginasPorPantalla === 1)) {
            _context6.next = 15;
            break;
          }

          _context6.next = 9;
          return call(getTextosPagina, libroId, numPagina);

        case 9:
          textosPagina = _context6.sent;
          textos = [].concat(textosPagina);
          _context6.next = 13;
          return put(cargarTextosAction(textos));

        case 13:
          _context6.next = 24;
          break;

        case 15:
          _context6.next = 17;
          return call(getTextosPagina, libroId, numPaginaIzquierda);

        case 17:
          textosPaginaIzquierda = _context6.sent;
          _context6.next = 20;
          return call(getTextosPagina, libroId, numPaginaIzquierda + 1);

        case 20:
          textosPaginaDerecha = _context6.sent;
          _textos2 = [].concat(textosPaginaIzquierda, textosPaginaDerecha);
          _context6.next = 24;
          return put(cargarTextosAction(_textos2));

        case 24:
        case 'end':
          return _context6.stop();
      }
    }
  }, _marked6, this);
}
/**
 * Monitoriza las acciones de crear, actualizar y eliminar textos de usuario
 */

export function watchTextosUsuario() {
  return _regeneratorRuntime.wrap(function watchTextosUsuario$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _context7.t0 = all;
          _context7.next = 3;
          return takeEvery(TEXTO_CREAR, handleTextoCrear);

        case 3:
          _context7.t1 = _context7.sent;
          _context7.next = 6;
          return takeEvery(TEXTO_ACTUALIZAR, handleTextoActualizar);

        case 6:
          _context7.t2 = _context7.sent;
          _context7.next = 9;
          return takeEvery(TEXTOS_ELIMINAR, handleTextosEliminar);

        case 9:
          _context7.t3 = _context7.sent;
          _context7.t4 = [_context7.t1, _context7.t2, _context7.t3];
          _context7.next = 13;
          return (0, _context7.t0)(_context7.t4);

        case 13:
        case 'end':
          return _context7.stop();
      }
    }
  }, _marked7, this);
}